// pusher.ts (Composable)
import Pusher from 'pusher-js'
import { ref } from 'vue'

const pusher = ref<Pusher | null>(null)

export function usePusher() {
  const pusher_key = import.meta.env.VITE_PUSHER_KEY

  console.log('🔍 usePusher called, pusher_key:', pusher_key ? 'exists' : 'missing')

  if (!pusher.value && pusher_key) {
    console.log('🚀 Creating Pusher instance...')
    pusher.value = new Pusher(pusher_key, {
      forceTLS: true,
      cluster: 'ap2'
    })

    // Log initial connection state
    console.log('📊 Initial Pusher connection state:', pusher.value.connection.state)

    // Set up connection status logging
    pusher.value.connection.bind('connected', () => {
      console.log('✅ Pusher connection: SUCCESS - Connected')
    })

    pusher.value.connection.bind('disconnected', () => {
      console.log('❌ Pusher connection: DISCONNECTED')
    })

    pusher.value.connection.bind('error', (err: any) => {
      console.error('❌ Pusher connection: ERROR -', err)
    })

    pusher.value.connection.bind(
      'state_change',
      (states: { previous: string; current: string }) => {
        console.log(`🔄 Pusher connection state changed: ${states.previous} → ${states.current}`)
      }
    )

    // Check if already connected
    if (pusher.value.connection.state === 'connected') {
      console.log('✅ Pusher connection: Already connected')
    }
  } else if (!pusher_key) {
    console.warn('⚠️ Pusher key not found in environment variables')
  } else {
    console.log('ℹ️ Pusher instance already exists, state:', pusher.value?.connection.state)
  }
  return pusher.value
}
